import { ReactNode } from 'react';
import NoItems from '@/components/ui/NoItems.tsx';

/**
 * Pustka tabeli — ten sam `NoItems`, co reszta aplikacji, tylko wyśrodkowany.
 *
 * Stan pusty stoi tu w wierszu na całą szerokość tabeli, a nie w kolumnie treści
 * karty, więc ikona i napis wyrównane do lewej wyglądałyby jak zgubione przy
 * krawędzi.
 */
const EmptyTable = ({
  title,
  description,
  icon,
  children,
}: {
  title?: string;
  description?: string;
  icon?: ReactNode;
  children?: ReactNode;
}) => (
  <NoItems
    className="mx-auto items-center text-center"
    title={title ?? 'Brak danych do wyświetlenia'}
    description={description}
    icon={icon}
  >
    {children}
  </NoItems>
);

export default EmptyTable;
